import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getKap = 'kap';
const getDetailKap = 'kap/';
const postKapUrl = 'kap';
const putKap = 'kap/';
const deleteKap = 'kap/';
const riwayatKap = 'riwayat-kap'
const exportDataKap = 'kap-export'

class KapService {
    getKap(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getKap + '?pageNo=' + currentPage + '&pageSize='+pageSize + '&filter='+filter,
            {
                headers: authHeader()
            });
    }

    getDetailKap(id_kap) {
        return axios.get(
            API_URL + getDetailKap + id_kap,
            {
                headers: authHeader()
            });
    }

    postKap(formData) {        
        return axios
        .post(
            API_URL + postKapUrl,
            formData,
            { headers: authHeader() }
        );
    }

    putKap(formData) {
        var headers = authHeader(); 

        return axios
        .put(
            API_URL + putKap + formData.id_kap, formData,
            { headers: authHeader() }
        );
    }

    deleteKap(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteKap + formData.id_kap,
                { headers: authHeader() },
            );
    }

    getRiwayatKap(currentPage, pageSize, filter, idKap) {
        return axios.get(
            API_URL + riwayatKap + '?pageNo=' + currentPage + '&pageSize='+pageSize + '&filter='+filter + '&idKap='+idKap,
            {
                headers: authHeader()
            });
    }

    exportDataKap() {
        return axios.get(API_URL + exportDataKap, {
            headers: authHeader(),
            responseType: 'blob',
        });
    }

}

export default new KapService();